import { STATIC_ASSETS_URL } from '.';
export const EMPTY_USER_IMAGE_PATH = "".concat(STATIC_ASSETS_URL, "/assets/no-photo/user-empty-state.svg");
export const EMPTY_ITEM_IMAGE_PATH = '/assets/no-photo/item.svg';
export const VINTED_LOGO_IMAGE_PATH = "".concat(STATIC_ASSETS_URL, "/assets/no-photo/vinted-welcome.png");
export const CUSTOM_SYSTEM_PHOTOS = Object.freeze(['de', 'de_babies', 'lt_babies']);
export let ImageOrientation; // Based on UserPhoto::PHOTO_SIZES

(function (ImageOrientation) {
  ImageOrientation[ImageOrientation["Degree0"] = 0] = "Degree0";
  ImageOrientation[ImageOrientation["Degree90"] = 1] = "Degree90";
  ImageOrientation[ImageOrientation["Degree180"] = 2] = "Degree180";
  ImageOrientation[ImageOrientation["Degree270"] = 3] = "Degree270";
})(ImageOrientation || (ImageOrientation = {}));

export let UserThumbnailSize; // Based on ItemPhoto::PHOTO_SIZES

(function (UserThumbnailSize) {
  UserThumbnailSize["Small"] = "thumb20";
  UserThumbnailSize["Medium"] = "thumb30";
  UserThumbnailSize["Default"] = "thumb50";
  UserThumbnailSize["Large"] = "thumb70";
  UserThumbnailSize["XLarge"] = "thumb90";
  UserThumbnailSize["X2Large"] = "thumb100";
  UserThumbnailSize["X3Large"] = "thumb140";
  UserThumbnailSize["X4Large"] = "thumb150";
  UserThumbnailSize["X5Large"] = "thumb175";
  UserThumbnailSize["X6Large"] = "thumb310";
})(UserThumbnailSize || (UserThumbnailSize = {}));

export let ItemThumbnailSize;

(function (ItemThumbnailSize) {
  ItemThumbnailSize["Small"] = "thumb70x100";
  ItemThumbnailSize["Medium"] = "thumb150x210";
  ItemThumbnailSize["Large"] = "thumb310x430";
  ItemThumbnailSize["XLarge"] = "thumb364x428";
  ItemThumbnailSize["X2Large"] = "thumb624x428";
})(ItemThumbnailSize || (ItemThumbnailSize = {}));